<template>
  <transition name="fade">
    <span v-if="hasError" class="input-error-msg">
      <slot></slot>
    </span>
  </transition>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class InputErrorMessage extends Vue {
  @Prop() hasError
}

export default toNative(InputErrorMessage)
</script>
